import { NavigationMenu } from '@msdyn365-commerce-modules/navigation-menu';

export { INavigationMenuViewProps, GridSize, INavigationMenuState } from '@msdyn365-commerce-modules/navigation-menu';
export default NavigationMenu;
